import React from "react";

import { SkeletonWrapper, Typography } from "components";

interface InsightCardProps {
  loading?: boolean;
  label: string;
  children: React.ReactNode;
  secondaryStat?: string;
  className?: string;
  attach?: "left" | "right";
  status?: "success" | "alert" | string;
}

// Attach can be used to join multiple cards, can be either "right" or "left"
export const InsightCard = ({ loading, label, children, secondaryStat, className, attach, status }: InsightCardProps) => (
  <div
    className={`farm-stat ${className} ${status === "alert" ? "alert" : ""} ${attach === "left" ? "attach-left" : ""} ${
      attach === "right" ? "attach-right" : ""
    }`}
  >
    <div className="stats-column">
      <SkeletonWrapper isLoading={loading} type="button" buttonShape="round" buttonSize="small">
        <div className="stats">
          <Typography variant="h1" color={status ? (status === "success" ? "green-400" : "red-500") : undefined}>
            {children}
          </Typography>
          {secondaryStat && (
            <Typography variant="paragraph-m" className="margin-left-25" color={status ? (status === "success" ? "green-400" : "red-500") : undefined}>
              {secondaryStat}
            </Typography>
          )}
        </div>
      </SkeletonWrapper>

      <Typography variant="paragraph-m">{label}</Typography>
    </div>
  </div>
);
